import { createSelector } from 'reselect';

const authorizationSelector = (state) => state.get('authorization');

const messagesSelector = createSelector(
    authorizationSelector, (authorization) => authorization.get('message')
);

const fieldsSelector = createSelector(
    authorizationSelector, (authorization) => authorization.get('fields')
);

const errorSelector = createSelector(
    authorizationSelector, (authorization) => authorization.get('error')
);

const loggedInUserSelector = createSelector(
    authorizationSelector, (authorization) => authorization.get('loggedInUser')
);

export default state => {

    return {
        loggedInUser: loggedInUserSelector(state),
        userMessage: messagesSelector(state),
        userFields: fieldsSelector(state),
        userError: errorSelector(state),
    };
};
